import { typedMemo } from '@utils';
import { TooltipOnEllipsis } from './TooltipOnEllipsis';

interface TooltipCellRendererProps {
  value: string;
}

export const TooltipCellRenderer = typedMemo(
  ({ value }: Readonly<TooltipCellRendererProps>) => {
    return <TooltipOnEllipsis title={value}>{value}</TooltipOnEllipsis>;
  },
);
